module.exports = __webpack_public_path__ + "img/pres-06.e3499672.png";